import { render, staticRenderFns } from "./EditRealbackProDialog.vue?vue&type=template&id=24c28ed2&scoped=true"
import script from "./EditRealbackProDialog.vue?vue&type=script&lang=js"
export * from "./EditRealbackProDialog.vue?vue&type=script&lang=js"
import style0 from "./EditRealbackProDialog.vue?vue&type=style&index=0&id=24c28ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c28ed2",
  null
  
)

export default component.exports